import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";
const ROOT = `${API_BASE_URL}/api/modem-recovery`;

// Per-employee daily ledger. `employeeId` is only needed when an admin is
// acting on someone else's ledger — omit it to act on your own.
export const getModemRecoveryEntriesApi = ({ employeeId, month, date } = {}) =>
  axios.get(ROOT, { params: { employeeId, month, date } });

export const getModemRecoverySummaryApi = (employeeId) =>
  axios.get(`${ROOT}/summary`, { params: { employeeId } });

// Admin-only — one row per employee who's been granted Modem Recovery access.
export const getModemRecoveryTeamSummaryApi = () => axios.get(`${ROOT}/team-summary`);

// Opening entry payload: { date, opening, note, employeeId? }
// Daily entry payload:   { date, recovered, retained, inHand, notFound, added, note, employeeId? }
export const createModemRecoveryEntryApi = (payload) => axios.post(ROOT, payload);

export const updateModemRecoveryEntryApi = (id, payload) =>
  axios.put(`${ROOT}/${id}`, payload);

export const deleteModemRecoveryEntryApi = (id, employeeId) =>
  axios.delete(`${ROOT}/${id}`, { params: { employeeId } });
